
// @flow
import { createSelector } from 'reselect';
import { COMPETITION_BASE_URL_FO } from 'constants/api';

const competitionEquipeSelector = (state) => state.settingsState.competitionsEquipes;
const competitionOvaleSelector = (state) => state.pageListState.competitions;
const competitionOvaleRencontreSelector = (state) => state.rencontreState.rencontre.competition;

export const selectCompetitionLink = createSelector(
  competitionEquipeSelector,
  competitionOvaleSelector,
  (competitionEquipes, competitionsOvale) => {
    if (Object.prototype.hasOwnProperty.call(competitionEquipes, competitionsOvale[0])) {
      const competitionSlug = competitionEquipes[`${competitionsOvale[0]}`].competitions_ffr_slug;

      return `${COMPETITION_BASE_URL_FO}competitions/${competitionSlug}/`;
    }

    return `${COMPETITION_BASE_URL_FO}`;
  }
);

export const selectCompetitionLinkOnRencontre = createSelector(
  competitionEquipeSelector,
  competitionOvaleRencontreSelector,
  (competitionEquipes, { id: competitionOvale }) => {
    if (Object.prototype.hasOwnProperty.call(competitionEquipes, competitionOvale)) {
      const competitionSlug = competitionEquipes[`${competitionOvale}`].competitions_ffr_slug;

      return `${COMPETITION_BASE_URL_FO}competitions/${competitionSlug}/`;
    }

    return `${COMPETITION_BASE_URL_FO}`;
  }
);
